<template>
  <div class="field field--textarea field--input">
    <div class="control">
      <label
        class="label"
        :class="{ 'is-fixed': inputValue !== '' }"
        :for="field.id">
        {{ field.label }}
      </label>
      <textarea
        v-if="!!v"
        class="input"
        :class="{
          'has-error': v.$error
        }"
        :id="field.id"
        @blur="autosize; v.$touch()"
        @keydown="autosize"
        v-model.trim="inputValue"
        :aria-describedby="fieldDescribedby"
        :name="field.id"
        :required="v.required"
        :maxlength="field.maxLength"
        ref="textBox"/>
      <textarea
        v-else
        class="input"
        :id="field.id"
        @blur="autosize"
        @keydown="autosize"
        v-model.trim="inputValue"
        :aria-describedby="fieldDescribedby"
        :name="field.id"
        :maxlength="field.maxLength"
        ref="textBox"/>
    </div>

    <p class="field--error"
       :id="field.idError"
       v-if="!!v && v.$error">
      <field-help
        v-for="(error, index) in field.errors"
        :v="v"
        :error="error"
        :key="index"/>
    </p>
    <p v-if="!!field.info" class="field--info">
      {{ field.info }}
    </p>
  </div>
</template>

<script>
  import FieldHelp from '@Feature/CustomForms/fields/FieldHelp/code/Scripts/components/field-help.vue';

  export default {
    name: 'field-textarea',

    components: {
      FieldHelp
    },

    props: {
      field: { type: Object, required: true, default: undefined },
      v: { type: Object, required: false, default: undefined },
      value: { type: String, required: true, default: undefined },
    },

    computed: {
      /**
       * Set propped value and emit on change to update parent value
       */
      inputValue: {
        get() {
          return this.value;
        },
        set(value) {
          // not covarable
          this.$emit('input', value);
        }
      },
      fieldDescribedby() {
        if (!!this.v) {
          return this.field.idError;
        }
        return false;
      }
    },

    methods: {
      autosize() {
        setTimeout(() => {
          if (this.inputValue.length) {
            this.$refs.textBox.style.height = this.$refs.textBox.scrollHeight + 2 + 'px';
          } else {
            this.$refs.textBox.removeAttribute('style');
          }
        },0);
      }
    }
  };
</script>

<style lang='scss' src="./field-textarea.scss"></style>
